import React from "react";

export const HEXLoadingSpinnerIcon = () => {
  return (
    <svg
      width="53"
      height="53"
      viewBox="0 0 53 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="c-hex-loadingspinner-icon"
    >
      <circle
        cx="26.0805"
        cy="26.0806"
        r="23.9194"
        stroke="white"
        strokeOpacity="0.15"
        strokeWidth="4.09103"
      />
      <path
        d="M49.9998 26.0806C49.9998 22.9395 49.3812 19.8291 48.1791 16.9271C46.977 14.025 45.2151 11.3882 42.994 9.16707C40.7729 6.94595 38.1361 5.18407 35.234 3.98201C32.332 2.77995 29.2216 2.16125 26.0805 2.16125"
        stroke="#11387F"
        strokeWidth="4.09103"
        strokeLinecap="round"
      />
    </svg>
  );
};
